<template>
  <div class="new-sds-container" v-loading="loading">
    <el-tabs type="border-card" v-model="tabModel" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="(item, index) in auditedList.slice().reverse()"
        :key="index"
        :name="'audited_tab' + (index + 1)"
      >
        <span slot="label"
          ><i class="el-icon-date"></i> {{ tabTitle("Version") }}
          {{ item.revNumber }}
        </span>
        <SdsContentComponentsVue
          :verified="verified"
          :detailData="item"
          :specData="specData"
          :language="language"
          :pageStatus="pageStatus"
        ></SdsContentComponentsVue>
      </el-tab-pane>
      <el-tab-pane
        v-loading="loading"
        element-loading-text="data loading"
        name="tab1"
        class="tab"
      >
        <span slot="label"
          ><i class="el-icon-date"></i> {{ tabTitle("Detail Manager") }}</span
        >
        <SdsContentComponentsVue
          v-if="detailData"
          :verified="verified"
          :detailData="detailData"
          :language="language"
          :pageStatus="pageStatus"
          @save-sds="saveHandle"
          @change-page-status="changePageStatus"
          @load-spec-item-code="loadSpecItemCodeData"
        ></SdsContentComponentsVue>
      </el-tab-pane>
      
    </el-tabs>
  </div>
</template>

<script>
import SdsContentComponentsVue from "./components/SdsContentComponents.vue";
import { apiServer } from "@/network/modules/detail-api";
export default {
  components: {
    SdsContentComponentsVue,
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      form: {},
      tabModel: "tab1",
      pageStatus: "Edit",
      language: "EN",
      revisionData: [],
      auditedList: [],
      verified:0,
      detailData: {
        revNumber: 0, // 版本号
        sds_type: "", // SDS 类型
        print_title: "", // 打印标题
        supplier_or_producer: "", // 供应商或生产商
        item_code: "", // 产品编码
        product_name: "", // 产品名称
        version_number: "", // 版本号
        customer_product_name: "", // 客户产品名称
        botanical_name: "", // 植物名称
        inci_name: "", // INCI 名称
        appearance: "", // 外观
        ph: "", // pH 值
        color: "", // 颜色
        solubility: "", // 溶解性
        odor: "", // 气味
        specific_gravity: "", // 比重
        storage: "", // 存储条件
        customs_classification: "", // 海关分类
        composition_information_on_ingredients: [
          // 成分信息
          {
            substance_name: "", // 物质名称
            cas_number: "", // CAS 号
            einecs_number: "", // EINECS 号
            r_phrase: "", // R 短语
            s_phrase: "", // S 短语
          },
        ],
        revision: [
          // 修订信息
          {
            approved_by: "", // 批准人
            edited_by: "", // 编辑人
            isComplete: false, // 是否完成
            reason: "", // 修订原因
            requested_by: "", // 请求人
            items_revised: "", // 修订说明
            revision_date: "", // 修订日期
          },
        ],
      },
      rowData: [
        {
          substance_name: "",
          cas_number: "",
          einecs_number: "",
          r_phrase: "",
          s_phrase: "",
        },
      ],
      specData: {},
    };
  },
  computed: {
    tabTitle() {
      return function (title) {
        if (this.language == "EN") {
          return title;
        }
        if (title == "Detail Manager") {
          return "详情管理";
        } else if (title == "Version") {
          return "版本";
        }
      };
    },
    sdsTypeList() {
      if (this.$route.query.language === "EN") {
        return [
          { name: "Liquid", value: "Liquid" },
          { name: "Oil", value: "Oil" },
          { name: "Powder", value: "Powder" },
        ];
      }
      return [
        { name: "TY-L", value: "TY-L" },
        { name: "TY-Oil", value: "TY-Oil" },
        { name: "TY-P", value: "TY-P" },
      ];
    },
    selectPlaceholderText() {
      if (this.$route.query.language === "EN") {
        return "Please Select";
      } else {
        return "请选择";
      }
    },
    placeholderText() {
      if (this.$route.query.language === "EN") {
        return "Please Input";
      } else {
        return "请输入";
      }
    },
  },
  methods: {
    handleTabClick(tab) {
      if (tab.name === "tab1") {
        let params = { ...this.$route.query };
        if (params.id) {
          this.pageStatus = "Edit";
        } else {
          this.pageStatus = "Add";
        }
      } else {
        this.pageStatus = "Detail";
      }
      
      // 修复 rev_number 计算逻辑，考虑倒序排序的影响
      if (tab.name.startsWith('audited_tab')) {
        // 从 tab 名称中提取索引号
        const tabIndex = parseInt(tab.name.replace('audited_tab', '')) - 1;
        // 由于 auditedList 是倒序排列，需要转换为正序索引
        const actualIndex = this.auditedList.length - 1 - tabIndex;
        // 获取实际数据中的 rev_number
        const actualItem = this.auditedList[actualIndex];
        if (actualItem && actualItem.revNumber !== undefined) {
          localStorage.setItem("sds_rev_number", actualItem.revNumber);
        } else {
          // 如果没有 rev_number，使用计算值作为备选
          localStorage.setItem("sds_rev_number", actualIndex + 1);
        }
      } else if (tab.name === 'tab1') {
        // 对于 tab1，使用默认值
        localStorage.setItem("sds_rev_number", "1");
      }
      
      localStorage.setItem("pageStatus", this.pageStatus);
    },
    
    // 初始化tab状态，确保Version Tabs在页面加载时不可编辑
    initializeTabStatus() {
      // 如果有审核列表数据，且当前选中的是Version Tab，则设置为Detail状态
      if (this.auditedList.length > 0 && this.tabModel.startsWith('audited_tab')) {
        this.pageStatus = "Detail";
        localStorage.setItem("pageStatus", this.pageStatus);
      } else if (this.auditedList.length > 0 && this.tabModel === 'tab1') {
        // 如果当前选中的是Detail Manager tab，且有审核数据，则设置为Edit状态
        let params = { ...this.$route.query };
        if (params.id) {
          this.pageStatus = "Edit";
        } else {
          this.pageStatus = "Add";
        }
        
        // 在 tab1 状态下设置默认的 rev_number
        localStorage.setItem("sds_rev_number", "1");
        localStorage.setItem("pageStatus", this.pageStatus);
      }
    },
    changePageStatus(status){
      console.info("changePageStatus==>",status)
      this.pageStatus = status;
    },
    // 加载详情数据
    loadDetailData() {
      // console.info("loadData==");

      let type = this.$route.query.type;
      let id = this.$route.query.id;
      if (id) {
        this.loading = true;
        apiServer.getDataByType(type, "getDetail", { id }, (data) => {
          if (typeof data.sdsType == "undefined" || data.sdsType == null) {
            data.sdsType = "Powder";
          }
          // console.info("data:",data)
          this.verified = data.verified;
          // console.info("this.verified111:",this.verified)
          localStorage.setItem("sds_create_time",data.createTime)
          let jsonValue = this.handleCopyData(data);

          if (this.$route.query.isCopy === "true") {
            jsonValue.revision = [
              {
                approved_by: "",
                edited_by: "",
                is_complete: false,
                reason: "",
                requested_by: "",
                items_revised: "",
                revision_date: "",
              },
            ];
            
            this.detailData = jsonValue;
            this.detailData.revNumber = 0;
            this.detailData.id = "";
          } else {
            this.detailData.id = data.id;
            jsonValue.item_code = data.itemCode;
            
            this.detailData = jsonValue;
            this.detailData.revNumber = data.revNumber;
            console.info("this.detailData.revNumber:", this.detailData.revNumber);
          }
          this.loading = false;
        });
      } else {
        // 初始化新建对象
        // console.info("this.detailData..:", this.detailData);
      }
    },
    loadAuditListData() {
      let type = this.$route.query.type;
      let id = this.$route.query.id;
      if (id) {
        this.loading = true;
        apiServer.getDataByType(type, "auditedList", { id }, (data) => {
          if(data.length>0){
            // 如果有审核数据，默认选中第一个Version Tab，并设置为不可编辑状态
            this.tabModel='audited_tab'+1;
            this.pageStatus = "Detail";
            
            // 设置默认的 rev_number，确保页面加载时就有正确的版本号
            if (this.auditedList.length > 0) {
              // 由于 auditedList 是倒序排列，第一个 tab 对应最新的版本
              const firstItem = this.auditedList[0];
              if (firstItem && firstItem.revNumber !== undefined) {
                localStorage.setItem("sds_rev_number", firstItem.revNumber);
              } else {
                // 如果没有 revNumber，使用默认值
                localStorage.setItem("sds_rev_number", "1");
              }
            }
          }
          data.forEach((item) => {
            
            // console.info("this.tabModel:",this.tabModel)
            // 创建混合数据结构，包含原始数据的字段和处理后的内容
            let processedItem = {
              ...item, // 保留原始数据的所有字段（包括 revNumber）
              ...this.handleCopyData(item) // 添加处理后的 jsonValue 内容
            };
            this.auditedList.push(processedItem);
          });
          // console.info("tmp:", this.auditedList);

          this.loading = false;
        });
      }
    },
    loadSpecItemCodeData(specModel) {
      // console.info("specModel1:", specModel);

      try {
        let language = localStorage.getItem("language").toLocaleLowerCase();
        this.detailData.customs_classification = "HTS#1302.19.9140";

        this.detailData.print_title = specModel.base_info.print_title || "";
        this.detailData.product_name = specModel.base_info.product_name || "";
        this.detailData.customer_product_name =
          specModel.base_info.customer_product_name || "";

        this.detailData.botanical_name = specModel.general_specification
          .botanical_name
          ? specModel.general_specification.botanical_name.toString()
          : "";
        this.detailData.inci_name = specModel.general_specification.inci_name
          ? specModel.general_specification.inci_name.toString()
          : "";
        this.detailData.appearance = specModel.general_specification.appearance
          ? specModel.general_specification.appearance.toString()
          : "";
        this.detailData.solubility = specModel.general_specification.solubility
          ? specModel.general_specification.solubility.toString()
          : "";

        if(language=='en'){
          this.detailData.specific_gravity =
          specModel.analysis.specific_gravity?.specification ?? "Not available";
        }else{
          this.detailData.specific_gravity =
          specModel.analysis.specific_gravity?.specification ?? "不存在";
        }
        // 类型映射转换
        this.detailData.sds_type = this.convertSpecProductTypeValue(specModel.base_info.product_type)
        // console.info("this.sds_type:", this.detailData.sds_type);

        this.detailData.ph = specModel.analysis.ph?.specification ?? "";
        this.detailData.color = specModel.analysis.color?.specification ?? "";
        this.detailData.odor = specModel.analysis.odor?.specification ?? "";

        this.detailData.storage = specModel.other_notes.storage || "";

        let paramsId = this.$route.query.id;
        // console.info("paramsId", paramsId);
        let substance_name = []
        if(specModel.general_specification.inci_name.length>0){
          substance_name = specModel.general_specification.inci_name;
        }else if(specModel.general_specification.botanical_name.length>0){
          substance_name = specModel.general_specification.botanical_name;
        }else if(specModel.general_specification.common_other_name.length>0){
          substance_name = specModel.general_specification.common_other_name;
        }

        if (typeof paramsId == "undefined" || paramsId == null) {
          this.detailData.composition_information_on_ingredients = [];
          for (
            let i = 0;
            i < substance_name.length;
            i++
          ) {
            this.detailData.composition_information_on_ingredients.push({
              substance_name: substance_name[i],
              cas_number: "",
              einecs_number: "",
              r_phrase: "",
              s_phrase: "",
            });
          }
        }
        // console.info("this.detailData0000:", this.detailData);
      } catch (error) {
        console.error("加载规格项数据时发生错误:", error);
        this.$message.error("加载数据失败，请稍后重试。");
      }
    },
    convertSpecProductTypeValue(input) {
      const mapping = {
        "CSFMU-S": "Powder",
        "CSFMU-B": "Powder",
        "F&V": "Powder",
        "FMU-D": "Powder",
        "HEXT": "Powder",
        "PCG": "Powder",
        "REXT": "Powder",
        "OEXT": "Powder",
        "PCG-CSFMU-S": "Powder",
        "PCG-CSFMU-B": "Powder",
        "SDNP": "Powder",
        "Liquid EXT-S": "Liquid",
        "Liquid EXT-B": "Liquid",
        "SDNP-L": "Liquid",
        "SHXTO": "Oil",
        "EHXTO": "Oil",
        "TY-P": "TY-P",
        "TY-L": "TY-L",
        "TY-EHXTO": "TY-Oil",
        "TY-SHXTO": "TY-Oil"
    };
      return mapping[input] || "Powder";
  },
    getTabAuditDetailData(item) {
      let tmp = JSON.parse(item.jsonValue);
      // console.info("getTabAuditDetailData:", tmp);
      return tmp;
    },
    // 添加行数据
    addRowDataHandle() {
      this.rowData.push({
        substance_name: "",
        cas_number: "",
        einecs_number: "",
        r_phrase: "",
        s_phrase: "",
      });
    },
    // 删除行数据
    removeRow(idx) {
      this.rowData.splice(idx, 1);
    },
    addVerifyListHandle() {},
    saveHandle(params, callback) {
      let type = this.$route.query.type;

      // console.info("params:",params)
      apiServer.getDataByType(type, "saveOrUpdate", params, (data) => {
        this.loading = false;
        callback(data);
        this.$message({
          type: "success",
          message: "Update Success",
        });
      });
    },
    vertifyHandle() {},
    back() {
      this.$router.go(-1);
    },
    handleCopyData(data) {
      if (typeof data == "undefined") {
        return;
      }
      let jsonValue = JSON.parse(data.jsonValue);
      const convertKeys = (obj) => {
        Object.keys(obj).forEach((key) => {
          const newKey = key.replace(/([A-Z])/g, "_$1").toLowerCase();
          if (newKey !== key) {
            obj[newKey] = obj[key];
            delete obj[key];
          }
          if (typeof obj[newKey] === "object" && obj[newKey] !== null) {
            convertKeys(obj[newKey]);
          }
        });
        return obj;
      };
      jsonValue = convertKeys(jsonValue);
      return jsonValue;
    },
  },
  created() {
    this.language = this.$route.query.language;
    this.loadDetailData();
    if (this.$route.query.isCopy != "true") {
      this.loadAuditListData();
    }

    let id = this.$route.query.id;
    
    let status = "Add";
    if (id) {
      status = "Edit";
    }

    this.pageStatus = status;

    localStorage.setItem("pageStatus", this.pageStatus);
    
    // 确保页面加载完成后，根据当前tab设置正确的状态
    this.$nextTick(() => {
      this.initializeTabStatus();
    });
  },
};
</script>

<style scoped>
@import "../style/new-spec.css";
</style>
